import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class PlFooter extends Component {
    render() {
        return (
            <div >
                <a href='' onClick={onUnsubClick} target="_blank">Wypisz</a>
            </div>
        );
    }
}

export default PlFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/plfooter.js